import { getProPageHeaders } from "@similarweb/pro-logic-components";

export const FE_CLIENT_VERSION_HEADER = "X-SW-UI-Version";

export const getFeClientVersion = (): string | undefined => {
    if (typeof window === "undefined") {
        return undefined;
    }
    return window.similarweb?.settings?.uiversion as string | undefined;
};

export const getHttpHeaders = (): Record<string, string> => {
    const uiVersion = getFeClientVersion();
    return {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Accept: "application/json",
        // eslint-disable-next-line @typescript-eslint/naming-convention
        "Content-Type": "application/json; charset=utf-8",
        ...getProPageHeaders(),
        ...(uiVersion ? { [FE_CLIENT_VERSION_HEADER]: uiVersion } : {}),
    };
};
